export const messages = {
  title: {
    id: 'admin/promotions.form.accumulations.title',
  },
  subtitle: {
    id: 'admin/promotions.form.accumulations.subtitle',
  },
}
